<div class="branch-promo {{ gradient ? 'branch-promo--gradient-' + gradient : '' }} {{ 'branch-promo--' + justifyContent }}">
  @if (!customBackground) {
    <app-image class="branch-promo__image" [src]="'https://aaaautoczimg.vshcdn.net/new/12664_2500x1667x80.jpg'" [sizes]="'1251w, 1350w, 1600w, 1920w, 2000w, 2500w'" [alt]="'#'" [fill]="true"></app-image>
  }
  <ng-content></ng-content>
</div>
